(async () => {
  if (window.__lbVjkCardsInitialized) return;
  window.__lbVjkCardsInitialized = true;
  const [{ Component }, { cartService }, { text }] = await Promise.all([
    import('@theme/component'), import('@theme/lb-cart-service'), import('@theme/lb-ui'),
  ]);
  class LittleBeesProductCard extends Component {
    connectedCallback() {
      super.connectedCallback();
      this.controller?.abort();
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.busy = false;
      this.initialPrice = this.querySelector('[data-price]')?.textContent;
      this.initialCompare = this.querySelector('[data-compare]')?.textContent;
      this.image = this.querySelector('.vjk-gc__media img');
      this.initialImage = this.image && { src: this.image.getAttribute('src'), srcset: this.image.getAttribute('srcset'), alt: this.image.alt };
      this.addEventListener('submit', event => this.submit(event), { signal });
      this.addEventListener('change', () => this.selectVariant(), { signal });
      this.addEventListener('click', event => {
        if (event.target.closest('[data-add]') && this.querySelector('[data-size]') && !this.variantId()) {
          event.preventDefault();
          this.message(text(this.dataset.isDesign === 'true' ? 'select_design' : 'select_option'));
          this.querySelector('[data-size]').focus();
        }
        if (event.target.closest('[data-minus]')) this.adjust(-1);
        if (event.target.closest('[data-plus]')) this.adjust(1);
      }, { signal });
      document.addEventListener('lb:cart:updated', event => this.render(event.detail.cart), { signal });
      this.render(cartService.current());
      cartService.get().then(value => this.render(value)).catch(() => {});
      document.dispatchEvent(new Event('lb:components:ready'));
    }
    disconnectedCallback() {
      super.disconnectedCallback();
      this.controller?.abort();
      clearTimeout(this.feedbackTimer);
    }
    variantId() { return this.querySelector('[data-size]')?.value || (!this.querySelector('[data-size]') && this.querySelector('[data-add]')?.dataset.variant) || ''; }
    rules() { return this.querySelector('[data-size] option:checked')?.dataset || this.querySelector('[data-add]')?.dataset || {}; }
    quantity(value = cartService.current()) { return (value?.items || []).filter(item => String(item.variant_id) === String(this.variantId())).reduce((sum, item) => sum + item.quantity, 0); }
    render(value) {
      if (!this.isConnected) return;
      const add = this.querySelector('[data-add]');
      const stepper = this.querySelector('[data-step]');
      if (!add || !stepper || this.dataset.available !== 'true') return;
      const quantity = this.quantity(value);
      add.hidden = quantity > 0;
      stepper.hidden = quantity === 0;
      add.disabled = this.busy;
      add.textContent = text(this.busy ? 'adding' : 'add');
      const max = Number(this.rules().max);
      const increment = Number(this.rules().increment) || 1;
      const plus = this.querySelector('[data-plus]');
      const minus = this.querySelector('[data-minus]');
      if (plus) plus.disabled = this.busy || (Number.isFinite(max) && max > 0 && quantity + increment > max);
      if (minus) minus.disabled = this.busy;
      const output = this.querySelector('[data-qty]');
      if (output) output.textContent = String(quantity);
      this.setAttribute('aria-busy', String(this.busy));
    }
    message(value, success = false) {
      const message = this.querySelector('[data-msg]');
      if (!message) return;
      clearTimeout(this.feedbackTimer);
      message.textContent = value;
      message.classList.toggle('lb-cart-success', success);
      if (success) {
        const link = document.createElement('a');
        link.href = this.dataset.cartUrl;
        link.textContent = text('view_cart');
        message.append(' ', link);
      }
    }
    selectVariant() {
      const option = this.querySelector('[data-size] option:checked');
      if (option) {
        this.querySelector('[data-price]').textContent = option.dataset.p || this.initialPrice;
        const compare = this.querySelector('[data-compare]');
        compare.textContent = option.dataset.c || this.initialCompare;
        compare.hidden = !option.dataset.c;
        const badge = this.querySelector('[data-badge]');
        if (badge) { badge.hidden = !option.dataset.c; badge.textContent = text('discount', { count: option.dataset.pct || 0 }); }
        if (this.image && this.initialImage) {
          this.image.src = option.dataset.image || this.initialImage.src;
          this.image.alt = option.dataset.imageAlt || this.initialImage.alt;
          if (option.dataset.image) this.image.removeAttribute('srcset');
          else if (this.initialImage.srcset) this.image.setAttribute('srcset', this.initialImage.srcset);
        }
        const quantity = this.querySelector('input[name="quantity"]');
        if (quantity) quantity.value = String(Number(option.dataset.minimum) || 1);
      }
      this.message('');
      this.render();
    }
    async submit(event) {
      event.preventDefault();
      if (this.busy || !this.variantId()) return;
      this.busy = true;
      this.render();
      try {
        const cart = await cartService.add(this.variantId(), Number(this.rules().minimum) || 1, this);
        this.message(text('added'), true);
        this.render(cart);
      } catch (error) { this.message(error.message || text('cart_error')); }
      finally { this.busy = false; this.render(); }
    }
    async adjust(direction) {
      if (this.busy || !this.variantId()) return;
      const delta = direction * (Number(this.rules().increment) || 1);
      const maximum = Number(this.rules().max);
      if (delta > 0 && maximum > 0 && this.quantity() + delta > maximum) return;
      this.busy = true;
      this.render();
      try {
        const cart = await cartService.change(this.variantId(), delta, this);
        this.message(text(this.quantity(cart) ? 'updated' : 'removed'));
      } catch (error) { this.message(error.message || text('cart_error')); }
      finally { this.busy = false; this.render(); }
    }
  }
  if (!customElements.get('lb-product-card')) customElements.define('lb-product-card', LittleBeesProductCard);
})();
